<modal-open-point id="modal-monto-minimo">
  <div normal>
    <modal-monto-minimo></modal-monto-minimo>
  </div>
</modal-open-point>
<modal-open-point id="confirmar-checkout-modal-1">
  <div normal>
    <confirmar-checkout-modal></confirmar-checkout-modal>
  </div>
</modal-open-point>
<modal-open-point id="vaciar-carro-modal-3">
  <div normal>
    <vaciar-carrito-modal-mmax></vaciar-carrito-modal-mmax>
  </div>
</modal-open-point>
<modal-open-point id="elegir-entrega-modal-4">
  <div normal>
    <modal-calendario-modal-mmax></modal-calendario-modal-mmax>
  </div>
</modal-open-point>
<div *ngIf="modo==='normal'">
  <div class="informer">
    <div class="titulogra">
      Carrito de compras
    </div>
  </div>
  <section>
    <div class="container">
      <div *ngIf="articulosConCantidad.length === 0" class="empty-cart-message">
        No hay productos en el carro, por favor agregue para comenzar a comprar
      </div>
      <div *ngIf="articulosConCantidad.length !== 0">
        <lista-productos-view [articulosIn]="articulosConCantidad" [modelo]="'resumendetail'">
        </lista-productos-view>
      </div>
      <div *ngIf='!ocultarPrecios'>
        <div class="total">
          Total: {{totales | currency}}
        </div>
      </div>
      <div class="botncontainer">
        <div (click)="preguntarVaciar()" class="noselect btons vaciar">
          Vaciar carrito
        </div>

        <div *ngIf="ocultarPrecios" class="facturacion-box" [class.facturacion-box-error]="mostrarErrorTipoFacturacion">
          <span class="facturacion-title">Tipo de facturación:</span>

          <label class="facturacion-option">
            <input
              type="radio"
              name="tipoFacturacion"
              [checked]="tipoFacturacion === 'A'"
              (change)="setTipoFacturacion('A')">
            A
          </label>

          <label class="facturacion-option">
            <input
              type="radio"
              name="tipoFacturacion"
              [checked]="tipoFacturacion === 'B'"
              (change)="setTipoFacturacion('B')">
            B
          </label>

          <div *ngIf="mostrarErrorTipoFacturacion" class="facturacion-error-text">
            Debe seleccionar el tipo de facturación.
          </div>
        </div>

        <div (click)="volverAtras()" onclick="window.scrollTo(0,0)" class="noselect btons conticompra">
          Seguir comprando
        </div>

        <div (click)="goCheckoutPc()" onclick="window.scrollTo(0,0)" class="noselect btons comprar">
          Comprar
        </div>
      </div>
    </div>
  </section>
  <div class="foo">
    <mmax-helpfootbar></mmax-helpfootbar>
    <foo-mariano-max></foo-mariano-max>
  </div>
</div>